import {createViewConfig} from '@sail/engine';
import {MenuProps} from './Menu';

export const MenuConfig = createViewConfig({
  name: 'Menu',
  props: {} as MenuProps,
});
